  export const workforceValidator = (workforce: any) => {
    const wf = workforce;

    if (!wf) return "You must assign at least one worker";

    const hasEmployees = Array.isArray(wf.employees) && wf.employees.length > 0;
    const hasContractors = Array.isArray(wf.contractors) && wf.contractors.length > 0;
    const hasSupervisors = Array.isArray(wf.supervisors) && wf.supervisors.length > 0;

    if (!hasEmployees && !hasContractors && !hasSupervisors) {
      return "You must assign at least one worker";
    }

    return true;
  }